module.exports = __webpack_public_path__ + "img/ic_20_report_progress-active.f1c29afa.svg";